export function removeToken() {
  localStorage.removeItem('api-token');
  const domain = (import.meta as any).env.VITE_SESSION_DOMAIN;
  document.cookie = `zkToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
}

export function storeToken(token: string) {
  localStorage.setItem('api-token', token);
  const domain = (import.meta as any).env.VITE_SESSION_DOMAIN;
  document.cookie = `zkToken=${token}; path=/; domain=${domain};`;
}
